export const article = {
  id: 152175,
  title: "Japandroids Reveal Who Covered Them the Best",
  subtitle: "",
  deck:
    'Drummer David Prowse on how an Italian shoegaze cover made him realize, "My life is pretty awesome"',
  slug: "japandroids_cover_song_be_forest_i_quit_girls",
  body:
    'If you scour the internet, you can find plenty of people covering <a href="https://exclaim.ca/artists/japandroids_jpndrds">Japandroids</a>\' 2012 hit "The House That Heaven Built," including a <a href="https://soundcloud.com/phoebebridgers/the-house-that-heaven-built-by" target="_blank">haunting ballad version by Phoebe Bridgers</a>. When asked about their favourite time anyone ever covered one of their songs, however, the Vancouver rock duo cast their minds further back to a more obscure song performed by a lesser-known band: the 2009 track "I Quit Girls" by Italian shoegaze trio <a href="https://exclaim.ca/artists/be_forest">Be Forest</a>.<br />\r\n<br />\r\nJapandroids drummer David Prowse tells Exclaim! that this was the first time he ever heard anyone cover one of their songs, and that he loved the dreamy shoegaze reinterpretation. The duo were so impressed that they even asked Be Forest to join them on an early European tour, resulting in both bands playing the song together on-stage.<br />\r\n<br />\r\nRead Prowse\'s account below, including his thoughts on why the song represented a pivotal turning point in the band\'s early rise to success. Listen to both versions of "I Quit Girls" at the bottom of the page.\r\n<div align="center" style="text-align: center;">\r\n<hr align="center" size="2" width="100%" /></div>\r\nAn Italian band called Be Forest covered "I Quit Girls" from our first record, <a href="https://exclaim.ca/music/article/japandroids-no_fun_city_rockers"><em>Post-Nothing</em></a>. It\'s the first Japandroids cover I can recall hearing, and it was pretty special for a few different reasons. It\'s surreal to have someone cover your music; it\'s kind of parallel with when you first start going out of town and going to new cities and having people show up at your shows. There\'s a feeling of all of a sudden being like, \'Whoa, are we are we a real band now?\' You realize some people are looking at your band the way that you look at other bands.<br />\r\n<br />\r\nObviously, the other thing that sticks out is that it\'s just a really cool cover. We weren\'t familiar with this band beforehand, but just hearing this really cool shoegaze reinterpretation of it was very exciting to listen to. Through that cover, both Brian and I became fans of that band.<br />\r\n<br />\r\nWe were starting tour in Europe about playing pretty small venues. And we were looking into options of a band to play with on a European tour. We were like, \'Well, why don\'t we just see about that Be Forest band? They obviously like our band and we like them, so why don\'t we just see if they want to do a tour with us?\' So we reached out, and we ended up doing this pretty extensive tour together all over Europe. They were really lovely people. The guitarist Nico even had "Crazy/Forever" [another early Japandroids song] tattooed on his body.<br />\r\n<br />\r\nEverything culminated with a show in the city they\'re from, Bologna, where we did a <a href="https://www.youtube.com/watch?v=ZcfHUPI8R4s" target="_blank">big double whammy performance of "I Quit Girls" and both bands played the song together</a>. We played it more in the vein of the Be Forest style. I didn\'t think about this until now, but I think we might have been influenced by that cover. We started playing "I Quit Girls" again on the <a href="https://exclaim.ca/music/article/japandroids-near_to_the_wild_heart_of_life"><em>Near to the Wild Heart of Life</em></a> tour, and we started playing it in a much more shoegaze-y way. I wonder if that Be Forest version planted that seed a little bit, because their version has a cool, super wash-y guitar sound and a more space-y interpretation.<br />\r\n<br />\r\n"I Quit Girls" seems like kind of an outlier. That song, I think, was the one we put the least amount of thought into when we recorded it. That\'s not the song I would have expected someone to cover. If I was going to hear a cover, maybe there\'s some songs that seemed more obvious, like "Wet Hair" or <a href="https://exclaim.ca/music/article/japandroids_jpndrds-young_hearts_spark_fire">"Young Hearts Spark Fire"</a> or something like that.<br />\r\n<br />\r\nIt\'s pretty wild: not only did this cool band cover us in a very flattering way, they\'re from halfway around the world and English isn\'t even their first language. The symbolic power of being, like, \'Wow, my life is taking some pretty amazing and unexpected turns.\' It\'s pretty far beyond anything you would have expected, to have a band from Italy cover your song in a really cool way and then end up going on tour with them in Europe and playing it together in their hometown of Bologna in front of a packed-out crowd of 300 or 400 people. Every once in a while, it\'s good to stop and think about how lucky you are, and this whole thing is pretty amazing example of that. Just like, \'Wow, my life is pretty awesome.\'<br />\r\n<br />\r\n<iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0" height="315" src="https://www.youtube.com/embed/Z3sS3qRGuCk" title="YouTube video player" width="560"></iframe><br />\r\n<br />\r\n<iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0" height="315" src="https://www.youtube.com/embed/9yCEZ35V9BM" title="YouTube video player" width="560"></iframe>',
  tags_arr: [717, 38, 33, 72, 34],
  exclaim_id: null,
  created_at: "2021-03-26T14:33:24.966-04:00",
  updated_at: "2021-03-31T10:59:33.998-04:00",
  live_at: "2021-03-31T10:21:00.000-04:00",
  photo_id: 76490,
  rating: null,
  paid: false,
  hide: false,
  issue_id: null,
  indexed: false,
  canonical_slug:
    "/music/article/japandroids_cover_song_be_forest_i_quit_girls",
  gated: false,
  canonical_url:
    "https://exclaim.ca/music/article/japandroids_cover_song_be_forest_i_quit_girls",
  festival_guide: null,
  venue_guide: null,
  tags: [
    {
      id: 717,
      title: "Uncovered",
      slug: "uncovered",
      collection: "contextual"
    },
    {
      id: 38,
      title: "Interview",
      slug: "interview",
      collection: "contextual"
    },
    {
      id: 33,
      title: "Features",
      slug: "features",
      collection: "content_type"
    },
    {
      id: 72,
      title: "Pop and Rock",
      slug: "pop-rock",
      collection: "genre"
    },
    {
      id: 34,
      title: "Music",
      slug: "music",
      collection: "media_type"
    }
  ],
  authors: [
    {
      id: 520,
      firstname: "Alex",
      lastname: "Hudson",
      slug: "alex_hudson",
      writer: true,
      photographer: false,
      videographer: false,
      created_at: "2015-12-22T22:41:23.000-05:00",
      updated_at: "2015-12-22T22:41:23.000-05:00"
    }
  ],
  artists: [
    {
      id: 14966,
      name: "Japandroids",
      the: false,
      slug: "japandroids_jpndrds",
      site: "",
      twitter: "",
      wiki: "",
      facebook: null,
      addedby: "exclaim",
      hide: false,
      created_at: "2010-12-14T06:15:12.000-05:00",
      updated_at: "2010-12-14T06:15:12.000-05:00",
      exclaim_id: 19218,
      sherpa_id: null,
      source: null,
      source_id: null,
      canonical_name: null,
      short_description: null
    },
    {
      id: 66078,
      name: "Be Forest",
      the: false,
      slug: "be_forest",
      site: "",
      twitter: "",
      wiki: "",
      facebook: "",
      addedby: "hand",
      hide: false,
      created_at: "2021-03-26T14:33:23.614-04:00",
      updated_at: "2021-03-26T14:33:23.614-04:00",
      exclaim_id: null,
      sherpa_id: null,
      source: null,
      source_id: null,
      canonical_name: null,
      short_description: null
    }
  ],
  labels: [],
  consoles: [],
  albums: [],
  photo: {
    id: 76490,
    cutline: "None",
    description: "",
    photo_file_name: "/images/japdroids.jpg",
    photo_content_type: "image/jpeg",
    photo_file_size: 58906,
    photo_updated_at: "2016-11-07T12:26:14.402-05:00",
    thumb_file_name: "/images/japdroidsS.jpg",
    thumb_content_type: "image/jpeg",
    thumb_file_size: 9341,
    thumb_updated_at: "2016-11-07T12:26:14.484-05:00",
    exclaim_id: null,
    artists: [
      {
        id: 14966,
        name: "Japandroids",
        the: false,
        slug: "japandroids_jpndrds",
        site: "",
        twitter: "",
        wiki: "",
        facebook: null,
        addedby: "exclaim",
        hide: false,
        created_at: "2010-12-14T06:15:12.000-05:00",
        updated_at: "2010-12-14T06:15:12.000-05:00",
        exclaim_id: 19218,
        sherpa_id: null,
        source: null,
        source_id: null,
        canonical_name: null,
        short_description: null
      }
    ],
    photographers: []
  }
};
